module.exports = __webpack_public_path__ + "static/media/tt.e93a0645.png";